import React, { useContext, useState } from "react";
import { API_ROUTE, Routes } from "../../Helpers/Constants";
import AuthenticationContext from '../../Store/Authentication-Context';
import Axios from "axios";

const ContractCommit = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const [hasAgreedToTerms, setHasAgreedToTerms] = useState(false);
    const [hasResponse, setHasResponse] = useState(false);
    const orgId = urlParams.get("signkey") ? urlParams.get("signkey") : "";
    const isReseller = urlParams.get("reseller") ? urlParams.get("reseller") : "";
    const isDirectCustomer = urlParams.get("directCustomer") ? urlParams.get("directCustomer") : "";
    const status = urlParams.get("status") ? urlParams.get("status") : "";
    const userPrice = urlParams.get("userPrice") ? urlParams.get("userPrice") : "";
    const priceName = urlParams.get("priceName") ? urlParams.get("priceName") : "";
    const termValue = urlParams.get("termValue") ? urlParams.get("termValue") : "";
    const isManaged = urlParams.get("isManaged") ? urlParams.get("isManaged") : "";
    
    const [nextUrl] = useState("/DirectDebitSettings?signkey=" + orgId);
    function handleButtonClick() {
        window.parent.postMessage('changeUrl', '*'); 
    }
    const { setAuthContext } = useContext(AuthenticationContext);

    async function termsUpdateUserData() {
        var tokenString = await setAuthContext("", new Date());
        setHasResponse(false);
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        try {
            const res = await fetch('https://api.ipify.org?format=json');
            const data = await res.json();
            const ipAddress = data.ip;
            const payload = {
                OrgId: orgId,
                IpAddress: ipAddress
            }
            if (orgId && ipAddress) {
                Axios.put(API_ROUTE + Routes.Update_User_Data + '/' + orgId , payload ,config)
                    .then((response) => {
                        setHasResponse(true);
                    })
                    .catch((reason) => {
                        if (reason?.response?.status === 440) {
                            window.location.href = "/TimeoutErrorHandler";
                        }
                    });
            }
        } catch (err) {
            console.error('termsUpdateUserData', err);
        }
    }
    return (
        <div style={{ padding: '1rem 5rem', border:'1px solid #dde2eb' }}>
            {status === 'Active' ?
                <div style={{ textAlign: 'center' }}>
                <span style={{ fontSize: '17px', fontWeight: '500', display: 'block' }}>If you need to change the bank account on your mandate please click the button below.</span>
                <a href={nextUrl} className="btn btn-primary mt-3 mb-3" disabled>Managed Current Direct Debit</a>
                <input type="hidden" id="PAYGPriceModelID" />
                <input type="hidden" id="ContractPriceModelID" />
                <br />
                <span id="status" style={{ color: "#FF3300" }}></span>

                    <span className='muted_text mb-2' style={{ textAlign: 'left' }}>
                        By creating a direct debit agreement you are accepting our <a href="https://www.virtualdcs.co.uk/download/CloudCover365-Terms.pdf" target="_blank" rel="noopener noreferrer">CloudCover 365 Terms and conditions</a>&#44;. You also confirm that you have the authority to do so on behalf of your organisation.
                    </span>

            </div>
                : ((isReseller === "true" && isManaged === "true") || (isReseller === "false" && (isDirectCustomer === false || isDirectCustomer === "false")))
                    ? <div style={{ textAlign: 'center' }}>
                        <span style={{ fontSize: '17px', fontWeight: '500', display: 'block' }}>Your account is currently not active, to continue to use this service you must talk to your service provider.</span>
                    </div>
                    : (status === 'Failed' || status === 'NoGC') &&
                    <>
                        <span style={{ fontSize: '17px', fontWeight: '500', display: 'flex', textAlign: 'center' }}>Your account is currently Inactive. To continue using the services, you need to have a live Direct Debit. Your current package is as follows.</span>
                        <div className="card" style={{ margin: '1.25rem 9rem', borderTopLeftRadius: '15px', borderTopRightRadius: '15px' }}>
                            <div className="card-header account_mangment_header" style={{ borderTopLeftRadius: '15px', borderTopRightRadius: '15px' } }>
                                <div style={{ textAlign: 'center' }}>
                                    <h3 className="card-title pricing-card-title">{priceName}</h3>
                                    <span className='fw-bold'>Price: </span><span className="small">{userPrice}/User</span><br />
                                    <span className='fw-bold'>Term: </span><span className="small">{termValue}</span>
                                    {/*<p>Disk Space outside of quota will be charged at &#163;{quotaValue}<br /></p>*/}
                                </div>

                            </div>
                            <div className="card-body">
                                <div className='fw-semibold me-4 ms-4 pe-4 ps-4' style={{ textAlign: 'center' }}>
                                    If you are happy with this package and wish to proceed. Please complete the agreement below.
                                    <hr className='account_managment_hr' />
                                </div>
                                <div className="me-4 ms-4">
                                    <span className='muted_text mb-2' style={{ textAlign: 'left' }}>
                                        By creating a direct debit agreement you are accepting our <a href="https://www.virtualdcs.co.uk/download/CloudCover365-Terms.pdf" target="_blank" rel="noopener noreferrer">CloudCover 365 Terms and conditions</a>&#44;. You also confirm that you have the authority to do so on behalf of your organisation.
                                    </span>
                                    <div className='muted_text mb-2 mt-3' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <input
                                            type="checkbox"
                                            id="acceptAccountInfoTerms"
                                            className="me-1"
                                            style={{ height: '10px', width: '10px' }}
                                            onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                setHasAgreedToTerms(isChecked);
                                                if (isChecked) {
                                                    termsUpdateUserData();
                                                } else {
                                                    setHasResponse(false);
                                                }
                                            }}
                                            checked={hasAgreedToTerms}
                                        />
                                        <label
                                            htmlFor="acceptAccountInfoTerms"
                                            style={{
                                                fontWeight: '300',
                                                fontFamily: "'Poppins', sans-serif",
                                                fontSize: '11px',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            Agree to Terms and Conditions
                                        </label>
                                    </div>
                                </div>

                                <div className="me-4 ms-4" style={{ display: 'flex', justifyContent: 'center' }}>
                                    <button
                                        //href={nextUrl}
                                        onClick={(e) => {
                                            if (!hasAgreedToTerms) {
                                                e.preventDefault();
                                            } else {
                                                e.preventDefault();
                                                window.location.href = nextUrl;
                                            }
                                        }}
                                        disabled={!hasAgreedToTerms || !hasResponse}
                                        style={{
                                            opacity: !hasAgreedToTerms || !hasResponse ? 0.6 : 1,
                                            cursor: !hasAgreedToTerms || !hasResponse ? 'not-allowed' : 'pointer',
                                            borderRadius: '17px'
                                        }}
                                        className="btn btn-primary mt-3 mb-3"
                                    >
                                        Activate your account now
                                    </button>
                                    <input type="hidden" id="PAYGPriceModelID" />
                                    <input type="hidden" id="ContractPriceModelID" />
                                    <br />
                                </div>

                            </div>
                        </div>
                        <span id="status" style={{ color: "#FF3300" }}></span>

                        <div style={{ textAlign: 'center', margin: '0 12rem', display: 'grid' }} className="mb-2">
                            <div className="mb-2">
                                <span className="me-2 muted_text" style={{ fontSize: '13px' }}>Not quite right for you?</span>
                            </div>
                            <div>
                                <button onClick={handleButtonClick} style={{                                                   //disabled={!hasAgreedToTerms ||!hasResponse}
                                    //opacity: !hasAgreedToTerms || !hasResponse ? 0.6 : 1,
                                    //cursor: !hasAgreedToTerms || !hasResponse ? 'not-allowed' : 'pointer',
                                    borderRadius: '17px'
                                }} className="btn btn-primary">View alternative packages</button>
                            </div>
                        </div>
                    </>
            }
            
        </div>
    );
}

export default ContractCommit;